import React, {useState, useEffect} from 'react'
import {sanitizeFilename} from '../lib/helpers'
import {imageUrlFor} from '../lib/image-url'
import DropdownSelect from './dropdownSelect'
import PortableText from './portableText'
import { FaArrowRight } from 'react-icons/fa'
import {Link} from 'gatsby'
import {isUserInRegion} from '../services/auth'
import FileIcon from './fileIcon'
import FileComponent from './fileComponent'

const AccordionLinkFile = ({item, userRegion}) => {

    // console.log('---> item: ', item)

    if(!item || !isUserInRegion(userRegion, item.region)) return ''

    return (
        <div style={{padding: '0.425rem 0'}}>
            {
                item._type === 'link' && <div><FaArrowRight size={22} color="#515155" /> <Link to={item.url || '#'}>{item.title}</Link></div>
            }
            {/* {
                item._type === 'fileComponent' && <div><FileIcon fileUrl={item.file.asset.url} /> <a href={item.file && item.file.asset ? item.file.asset.url +'/'+ sanitizeFilename(item.file.asset.originalFilename) : '#'} target='_blank'>{item.title}</a></div>
            } */}
            {
                item._type === 'fileComponent' && <FileComponent item={item} />
            }
        </div>
    )
}

export default AccordionLinkFile